// Visuell rendering av TextBlock i canvas. block.html kommer från TinyMCE och
// behandlas som trusted HTML — samma princip som direkt-läget använder idag.
// Font läses från canvas-context så att docSettings-ändringar syns direkt.

import { Box } from '@mui/material';
import { useBlockCanvas } from '../canvasContext';
import { DEFAULT_FONT_STACK, TextBlock } from '../types';

type Props = { block: TextBlock };

export const TextBlockView = ({ block }: Props) => {
  const ctx = useBlockCanvas();
  const fontFamily = ctx?.docSettings.bodyFontFamily ?? DEFAULT_FONT_STACK;
  return (
    <Box
      sx={{
        p: '12px 30px',
        color: '#666666',
        fontFamily,
        fontSize: '17px',
        lineHeight: '25px',
      }}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: block.html }}
    />
  );
};

export default TextBlockView;
